import { RoleEnum } from './role.util';

export class AuthorizationUtil {
  static GROUP_ACCOUNTANT = [RoleEnum.MODERATOR.toString(), RoleEnum.ACCOUNTANT.toString()];

  static GROUP_OFFICE = [RoleEnum.MODERATOR.toString(), RoleEnum.COMMUNITY_OFFICE.toString()];

  static GROUP_RELIGIOUS = [
    RoleEnum.MODERATOR.toString(),
    RoleEnum.COMMUNITY_OFFICE.toString(),
    RoleEnum.COMMUNITY_RELIGIOUS.toString()
  ];

  static GROUP_COMMUNITY_ALL = [
    RoleEnum.MODERATOR.toString(),
    RoleEnum.COMMUNITY_OFFICE.toString(),
    RoleEnum.COMMUNITY_RELIGIOUS.toString(),
    RoleEnum.COMMUNITY_RESPONSIBLE.toString()
  ];

  static GROUP_COMMUNITY_MANAGEMENT = [
    RoleEnum.MODERATOR.toString(),
    RoleEnum.COMMUNITY_OFFICE.toString(),
    RoleEnum.COMMUNITY_RESPONSIBLE.toString()
  ];

  static GROUP_MEMBERSHIP_ALL = [
    RoleEnum.MODERATOR.toString(),
    RoleEnum.MEMBERSHIP_OFFICE.toString()
  ];

  static GROUP_EDUCATION_WITHOUT_ASSISTANT = [
    RoleEnum.MODERATOR.toString(),
    RoleEnum.EDUCATION_OFFICE.toString()
  ];

  static GROUP_EDUCATION = [
    ...AuthorizationUtil.GROUP_EDUCATION_WITHOUT_ASSISTANT,
    RoleEnum.EDUCATION_OFFICE_ASSISTANT.toString()
  ];

  static GROUP_EDUCATION_WITHOUT_MODERATOR = [
    RoleEnum.EDUCATION_OFFICE.toString(),
    RoleEnum.EDUCATION_OFFICE_ASSISTANT.toString()
  ];

  static GROUP_TEACHER_MANAGEMENT = [
    ...AuthorizationUtil.GROUP_EDUCATION,
    RoleEnum.INSPECTOR.toString()
  ];

  static GROUP_SCHOOL = [
    RoleEnum.MODERATOR.toString(),
    RoleEnum.EDUCATION_OFFICE.toString(),
    RoleEnum.EDUCATION_OFFICE_ASSISTANT.toString(),
    RoleEnum.SCHOOL_OFFICE.toString()
  ];

  static GROUP_SCHOOL_INSPECTOR = [
    RoleEnum.MODERATOR.toString(),
    RoleEnum.SCHOOL_OFFICE.toString(),
    RoleEnum.INSPECTOR.toString()
  ];

  static GROUP_INSPECTOR = [
    RoleEnum.MODERATOR.toString(),
    RoleEnum.EDUCATION_OFFICE.toString(),
    RoleEnum.EDUCATION_OFFICE_ASSISTANT.toString(),
    RoleEnum.SCHOOL_OFFICE.toString(),
    RoleEnum.INSPECTOR.toString()
  ];

  static GROUP_EDUCATION_ALL = [
    RoleEnum.MODERATOR.toString(),
    RoleEnum.EDUCATION_OFFICE.toString(),
    RoleEnum.EDUCATION_OFFICE_ASSISTANT.toString(),
    RoleEnum.SCHOOL_OFFICE.toString(),
    RoleEnum.INSPECTOR.toString(),
    RoleEnum.TEACHER.toString()
  ];
}
